import {
  AgxSpacer,
  AgxTypography,
  dateOnlyToDate,
  toDateOnlyString,
  toInclusiveDate,
} from '@urbanx/agx.ui-components2';
import { useEffect } from 'react';
import { allowedCommissionTypes } from 'pages/finance/commission/commission/CommissionEnums';
import AgreementCommissionStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/AgreementCommissionStageSteps';
import AppointmentPeriod from 'pages/campaigns/components/campaignTasks/AgreementCompliance/NSW/AppointmentPeriod';
import { updateAgreementDetailsAppointmentPeriod } from 'pages/campaigns/components/campaignTasks/AgreementCompliance/NSW/appointmentPeriodAgreementDetails';
import { TaskModalPageProps } from '../TaskModalPageProps';
import { resolveNswAgreementComplianceTaskLayout } from '../agreementComplianceTaskLayout';

const toDisplayEndDate = (endDateExclusive?: Date | string | null) =>
  endDateExclusive ? (dateOnlyToDate(toInclusiveDate(endDateExclusive)) ?? undefined) : undefined;

const toDisplayDate = (date?: Date | string | null) =>
  date ? (dateOnlyToDate(toDateOnlyString(date)) ?? undefined) : undefined;

const NswAgreementComplianceTypePage = ({
  tasks,
  taskNumber,
  toggleTaskStepForTask,
  agreementDetails,
  onAgreementDetailsUpdated,
  commissionDetails,
  currentCommissionInfo,
  onCommissionUpdated,
  registerTaskModalPageValidation,
}: TaskModalPageProps) => {
  const { appointmentPeriodSteps, commissionStep } = resolveNswAgreementComplianceTaskLayout(tasks);

  useEffect(() => {
    if (!agreementDetails) return;

    const dates = [Boolean(agreementDetails.startDate), Boolean(agreementDetails.endDateExclusive)];

    appointmentPeriodSteps.forEach(({ task, step }, index) => {
      if (step.isCompleted !== dates[index]) {
        toggleTaskStepForTask(task.id, step.order ?? 0, dates[index]);
      }
    });
  }, [agreementDetails, appointmentPeriodSteps, toggleTaskStepForTask]);

  if (!agreementDetails || !onAgreementDetailsUpdated || !onCommissionUpdated) {
    return null;
  }

  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography size="large" type="label" id="step2title" color="var(--text-primary)">
        {`Step ${taskNumber}: Appointment Dates & Commission`}
      </AgxTypography>
      <AgxTypography size="medium" type="title" id="modalTitle-appointment-period">
        Appointment Period
      </AgxTypography>
      <AppointmentPeriod
        value={{
          startDate: toDisplayDate(agreementDetails.startDate),
          endDate: toDisplayEndDate(agreementDetails.endDateExclusive),
        }}
        onChange={(updated) => {
          onAgreementDetailsUpdated({
            id: 'period',
            value: updateAgreementDetailsAppointmentPeriod(agreementDetails, updated),
          });
        }}
      />
      <AgreementCommissionStageSteps
        commissionDetails={commissionDetails}
        onCommissionUpdated={onCommissionUpdated}
        allowedCommissionTypes={allowedCommissionTypes}
        currentCommissionInfo={currentCommissionInfo}
        commissionStep={commissionStep.step}
        updateCommissionTaskStep={(isCompleted) =>
          toggleTaskStepForTask(commissionStep.task.id, commissionStep.step.order ?? 0, isCompleted)
        }
        registerTaskModalPageValidation={registerTaskModalPageValidation}
      />
    </AgxSpacer>
  );
};

export default NswAgreementComplianceTypePage;
